$(function ($) {
    "use strict";


    // serializeObject
    $.fn.serializeObject = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || "");
            } else {
                o[this.name] = this.value || "";
            }
        });
        return o;
    };

    //$('.newsletter').each(function () {
    //    var $module = $(this);
    //    var $form = $('form#newsletter');

    //    bindValidation($form);

    //    function bindValidation($form) {
    //        $form.validate({
    //            rules: {
    //                privacy: { required: true },
    //                email: {
    //                    required: true,
    //                    email: true
    //                }
    //            },
    //            messages: {
    //                privacy: $('[name="privacy"]').data("required"),
    //                email: {
    //                    required: $('[name="email"]').data("required"),
    //                    email: $('[name="email"]').data("email")
    //                }
    //            }
    //        });
    //    }
    //});
    //$('.module-footer').each(function () {
    //    var $form = $(this);
    //    $form.find(".footer-newsletter__form__group button[name=email]").on("click",
    //        function() {
    //            $form.find(".footer-newsletter").hide();
    //        });
    //});
});